var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.48026 12.5L0.906796 7.56066C0.364402 6.97488 0.364401 6.02513 0.906796 5.43934L5.48025 0.500002M1.3136 6.5L15.5 6.5",
    stroke: "white",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowActive);
export default __webpack_public_path__ + "static/media/icon-arrow-active.6f8d1673d6bb494193cbf1a7b8b9b556.svg";
export { ForwardRef as ReactComponent };